<template>
  <div>
      <input
          :id="id"
          v-model="val"
          class="form-control"
          lang="en"
          :disabled="disabled"
          type="number"
          :step="step"
          :min="min"
          @keypress="isNumber"
      >
      <span v-if="errorText" class="help-block">
          <p style="color: darkred">{{ errorText }}</p>
      </span>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    errors: {
      type: Object,
      default: () => {},
    },
    step: {
      type: [String, Number],
      default: 1
    },
    min: {
      type: [String, Number],
      default: 0
    },
    float: {
      type: Boolean,
      default: true
    },
    negative: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      id: `form_${this.name}`,
      val: null,
      errorText: false,
    }
  },
  watch: {
    errors: function (value) {
      if (!value) {
        this.errorText = ''
        this.formGroupClass = 'form-group'
        return
      }
      if (value[this.name]) {
        this.errorText = Object.values(value[this.name]).join()
        this.formGroupClass += ' has-error'
      }
    },
    val: function (value) {
      this.$emit('input', value)
    },
    value: function (v) {
      this.val = v
    },
  },
  mounted: function () {
    if (this.value) {
      this.val = this.value
    }

    this.$emit('input', this.value)
  },
  methods: {
    isNumber(evt) {
      if (evt.metaKey) {
        return
      }
      const key = evt.key
      let val = this.val ? this.val : ''
      if (key === '-') {
        val = key + val
      } else {
        val += key
      }
      const pattern = this.getProperPattern()
      const valid = (val.match(pattern) || []).length > 0
      if (this.float) {
        const isFirstDot = (val.match(/^\.$/) || []).length > 0
        if (isFirstDot) {
          this.val = val.replace(/^\.$/, '0')

          return
        }
      }
      if (!valid) {
        evt.preventDefault()
      }
    },
    getProperPattern() {
      const posFloatPattern = /^\d*\.?\d{0,2}$/
      const negFloatPattern = /^-?\d*\.?\d{0,2}$/
      const posIntPattern = /^\d*$/
      const negIntPattern = /^-?\d*$/
      if (this.float && this.negative) {
        return negFloatPattern
      } else if (this.float && !this.negative) {
        return posFloatPattern
      } else if (!this.float && this.negative) {
        return negIntPattern
      } else if (!this.float && !this.negative) {
        return posIntPattern
      }
    },
  },
}
</script>
